import React from "react";

export const Eye = ({ color }: { color: string }) => (
  <svg
    width="25"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -7 40 40"
  >
    <g id="Layer_1">
      <title>Eye</title>
      <path
        stroke={color}
        strokeWidth="5"
        id="svg_1"
        d="m20,3.21403c-9.08315,0 -16.25,9.28537 -16.25,9.28537s7.16685,9.28657 16.25,9.28657c6.94657,0 16.25,-9.28657 16.25,-9.28657s-9.30343,-9.28537 -16.25,-9.28537zm0,15.07157c-3.18861,0 -5.7862,-2.59639 -5.7862,-5.7862s2.59759,-5.7862 5.7862,-5.7862s5.7862,2.59759 5.7862,5.7862s-2.59759,5.7862 -5.7862,5.7862zm0,-9.1638c-1.86454,0 -3.37759,1.51185 -3.37759,3.37759c0,1.86574 1.51185,3.37759 3.37759,3.37759c1.86574,0 3.37759,-1.51185 3.37759,-3.37759c0,-1.86454 -1.51185,-3.37759 -3.37759,-3.37759z"
      />
      <path
        id="svg_2"
        d="m159.27998,27.5283c-0.03773,0 -0.0675,0.03857 -0.0675,0.03857s0.02977,0.03858 0.0675,0.03858c0.02886,0 0.0675,-0.03858 0.0675,-0.03858s-0.03865,-0.03857 -0.0675,-0.03857zm0,0.06261c-0.01325,0 -0.02404,-0.01079 -0.02404,-0.02404s0.01079,-0.02404 0.02404,-0.02404s0.02404,0.01079 0.02404,0.02404s-0.01079,0.02404 -0.02404,0.02404zm0,-0.03807c-0.00775,0 -0.01403,0.00628 -0.01403,0.01403c0,0.00775 0.00628,0.01403 0.01403,0.01403c0.00775,0 0.01403,-0.00628 0.01403,-0.01403c0,-0.00775 -0.00628,-0.01403 -0.01403,-0.01403z"
        stroke={color}
        fill={color}
      />
    </g>
  </svg>
);
